/**
 * Состояние модуля results
 * Отслеживание активных запросов и их отмены
 */

// ⛓️ CURSOR_ANCHOR:search:results-state

// Переменная для отслеживания активного запроса и его отмены
var activeSearchRequest = null;
var currentSearchId = 0;

// Функция для отмены активного запроса
function cancelActiveRequest() {
  if (activeSearchRequest) {
    activeSearchRequest.abort();
    activeSearchRequest = null;
  }
}

// Функция для получения нового ID запроса
function getNextSearchId() {
  currentSearchId++;
  return currentSearchId;
}

// Функция для установки активного запроса
function setActiveRequest(abortController) {
  activeSearchRequest = abortController;
}

// Функция для очистки активного запроса
function clearActiveRequest() {
  activeSearchRequest = null;
}

// Функция для проверки актуальности запроса
function isRequestCurrent(searchId) {
  return searchId === currentSearchId;
}

// Экспорт для использования в других модулях results/
window.SEARCH_RESULTS_STATE = {
  cancelActiveRequest: cancelActiveRequest,
  getNextSearchId: getNextSearchId,
  setActiveRequest: setActiveRequest,
  clearActiveRequest: clearActiveRequest,
  isRequestCurrent: isRequestCurrent
};

